import { ReactNode, ReactElement } from "react";
import styles from "./Container.module.scss";

const Container = ({ children }: { children: ReactNode }): ReactElement => (
  <main className={styles.container}>{children}</main>
);

export default Container;
